import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductRewardsCallout',
  props: {
    points: null,
    showPoints: { type: Boolean }
  },
  setup(__props: any) {



function joinRewards() {
	Blain.Rewards.showJoinRewardsSidePanel();
}

return { __sfc: true,joinRewards }
}

})